import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import { theme } from "../../theme"
import { ColorVariant, getVariantColor, getVariantHoverColor } from "../../../utils/theme-helpers"

interface ButtonProps {
  title: string
  onClick?: () => void
  icon?: React.ReactNode
  disabled?: boolean
  leftIcon?: React.ReactNode
  variant?: ColorVariant
}

const ButtonContainer = styled.button<{
  disabled?: boolean
  variant?: ColorVariant
  bgColor: string
  hoverColor: string
}>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  border: ${(props) =>
    props.variant === "light"
      ? `1px solid ${props.theme.colors.greyDark}`
      : props.variant === "light_transparent"
        ? `1px solid ${props.theme.colors.white}`
        : "none"};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  padding: 8px 16px;
  background: ${(props) => (props.variant === "light_transparent" ? "rgba(0.0, 0.0, 0.0, 0.0)" : props.bgColor)};
  display: flex;
  align-items: center;
  ${(props) => props.disabled && "background: #C3C3C3"};
  height: 40px;

  :hover {
    background: ${(props) => props.hoverColor};
  }
  :active {
    box-shadow: none;
  }
`

const ButtonTextSmall = styled.div<{ textAlign?: string; color?: string }>`
  font-size: 14px;
  color: ${(props) => props.color ?? props.theme.colors.greyDark};
  text-align: ${(props) => props.textAlign ?? "center"};
  font-family: "Inter", sans-serif;
  font-weight: 600;
  white-space: nowrap;
`

const SmallButton: React.FunctionComponent<ButtonProps> = ({
  title,
  onClick,
  icon,
  disabled,
  leftIcon,
  variant = "light",
}) => {
  const [color, setColor] = React.useState(theme.colors.white)
  const [hoverColor, setHoverColor] = React.useState(theme.colors.greyLight)

  React.useMemo(() => {
    setColor(getVariantColor(variant))
    setHoverColor(getVariantHoverColor(variant))
  }, [variant])

  return (
    <ButtonContainer
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      variant={variant}
      bgColor={color}
      hoverColor={hoverColor}
    >
      {leftIcon && (
        <>
          {leftIcon} <Spacer spacing={0.5} />
        </>
      )}
      <ButtonTextSmall color={variant === "light" || variant === "yellow" ? theme.colors.greyDark : theme.colors.white}>
        {title}
      </ButtonTextSmall>
      {icon && <Spacer spacing={0.5} />}
      {icon}
    </ButtonContainer>
  )
}

export default SmallButton
